module.exports = __webpack_public_path__ + "static/img/center_bj.7b01bbaf.png";